import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import './login.css';

const Login = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <p>Cargando...</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <img src="/logo512.png" alt="Logo" className="login-logo" />
        <h1>Glaciar Ingeniería</h1>
        <p className="login-description">
          Accedé a tu cuenta para continuar...
        </p>
        <button 
          onClick={() => loginWithRedirect()} 
          className="login-button"
        >
          Iniciar Sesión
        </button>
      </div>
    </div>
  );
};

export default Login;
